import { UserTransactionReason } from '../UserTransactionReason'
import { match } from 'utils/pattern-match-util'
import { Nillable } from 'types/definitions'

/**
 * Formats the transaction reason to a string.
 * @param reason
 */
export function formatTransactionReason(
  reason: Nillable<UserTransactionReason>,
): string {
  if (!reason) {
    return ''
  }

  return match(reason, {
    [UserTransactionReason.Unknown]: () => 'Unknown',
    [UserTransactionReason.BackgroundCheck]: () => 'Background check abatement',
    [UserTransactionReason.Penalty]: () => 'Penalty abatement',
    [UserTransactionReason.Bonus]: () => 'Bonus',
    [UserTransactionReason.MiscPayment]: () => 'Misc. payment',
    [UserTransactionReason.MiscAbatement]: () => 'Misc. abatement',
  })
}
